export interface IGroupOption {
  id: number;
  name: string;
}

export class GroupOption implements IGroupOption {
  id: number;
  name: string;

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
  }
}
